export interface Artwork {
  id: string;
  title: string;
  medium: string;
  salesPrice: string;
  salesPriceWithFrame?: string;
  image?: string;
}

export const mutatingWondersData: Artwork[] = [
  {
    id: "two-seeds-ground",
    title: "Two Seeds. Ground",
    medium: "Burnt Teakwood + Copper",
    salesPrice: "77,000",
    image: "/images/mutating-wonders/Two Seeds. Ground.png"
  },
  {
    id: "two-seeds-rising",
    title: "Two Seeds. Rising", 
    medium: "Burnt Teakwood + Copper",
    salesPrice: "222,000",
    image: "/images/mutating-wonders/Two Seeds. Rising.png"
  },
  {
    id: "raw-seeds-0102",
    title: "Raw Seeds. 0102",
    medium: "Teakwood + Burnt teakwood + copper",
    salesPrice: "22,000",
    image: "/images/mutating-wonders/Raw Seeds. 0102.png"
  },
  {
    id: "human-rising",
    title: "Human Rising",
    medium: "Burnt Teakwood + Copper",
    salesPrice: "111,000",
    image: "/images/mutating-wonders/Human Rising.png"
  },
  {
    id: "human-breakdown",
    title: "Human Breakdown",
    medium: "Burnt Teakwood + Copper", 
    salesPrice: "44,000",
    image: "/images/mutating-wonders/Human Breakdown.png"
  },
  {
    id: "human-strong",
    title: "Human Strong",
    medium: "Burnt Teakwood + Copper",
    salesPrice: "55,000",
    image: "/images/mutating-wonders/Human Strong.png"
  },
  {
    id: "cloned-wonders",
    title: "Cloned Wonders",
    medium: "Burnt Teakwood + Copper",
    salesPrice: "111,000",
    image: "/images/mutating-wonders/Cloned Wonders.png"
  },
  {
    id: "growing-wonder",
    title: "Growing Wonder",
    medium: "Burnt Teakwood + Copper",
    salesPrice: "44,000",
    image: "/images/mutating-wonders/Growing Wonder.png"
  },
  {
    id: "germination-i",
    title: "Germintion. I",
    medium: "Black ink on paper",
    salesPrice: "11,200",
    salesPriceWithFrame: "12,200",
    image: "/images/mutating-wonders/Germintion. I.jpg"
  },
  {
    id: "germination-ii",
    title: "Germintion. II",
    medium: "Black ink on paper",
    salesPrice: "11,200",
    salesPriceWithFrame: "12,200",
    image: "/images/mutating-wonders/Germintion. II.jpg"
  },
  {
    id: "conversation",
    title: "Conversation",
    medium: "Black ink on paper",
    salesPrice: "11,200",
    salesPriceWithFrame: "12,200",
    image: "/images/mutating-wonders/Conversation.jpg"
  },
  {
    id: "germination-iiii",
    title: "Germintion. IIII",
    medium: "Black ink on paper",
    salesPrice: "11,200",
    salesPriceWithFrame: "Frame not available",
    image: "/images/mutating-wonders/Germintion. IIII.jpg"
  },
  {
    id: "germination-iii",
    title: "Germintion. III",
    medium: "Black ink on paper",
    salesPrice: "11,200",
    salesPriceWithFrame: "Frame not available",
    image: "/images/mutating-wonders/Germintion. III.jpg"
  },
  {
    id: "process",
    title: "Process",
    medium: "Black ink on paper",
    salesPrice: "11,200", 
    salesPriceWithFrame: "Frame not available",
    image: "/images/mutating-wonders/Process.jpg"
  }
]; 